import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Konami Code: Up, Up, Down, Down, Left, Right, Left, Right, B, A
const KONAMI_CODE = [
    'ArrowUp', 'ArrowUp',
    'ArrowDown', 'ArrowDown',
    'ArrowLeft', 'ArrowRight',
    'ArrowLeft', 'ArrowRight',
    'b', 'a'
];

const useKonamiCode = () => {
    const navigate = useNavigate();
    const inputRef = useRef([]);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Clear sequence after 2 seconds of inactivity
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                inputRef.current = [];
            }, 2000);

            // Add key to sequence (normalize to lowercase for letters)
            const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
            inputRef.current.push(key);

            // Keep only the last N keys (where N is the length of the code)
            if (inputRef.current.length > KONAMI_CODE.length) {
                inputRef.current.shift();
            }

            // Check if sequence matches
            if (inputRef.current.length === KONAMI_CODE.length) {
                const match = inputRef.current.every((key, i) => key === KONAMI_CODE[i]);
                if (match) {
                    inputRef.current = [];
                    navigate('/comet-game');
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [navigate]);
};

export default useKonamiCode;
